import request from '@/utils/request'

// 查询专题列表
export const getAllTeacher = (params) => {
  return request({
    method: 'GET',
    url: '/v2/api/teacher/getAllAnchor',
    params: { ...params, status: 1 }
  })
}
